<template>
  <div class="xuliezhen">
    
    <img v-for="n in parseInt(count)" class="ddd loadimg" v-show="isshowlist[n-1]" :[isalljiazai]="resourcepath + '/images/xuliezhentest/'+(n-1)+'.png'" />
  </div>
</template>
<script>
import { mapState} from "vuex";
import {resourcepath } from "@/commonjs/commonfn.js";
export default {
  name: "xuliezhen",
    props: ["starttime", "isloop","count"],
  data() {
    return {
      resourcepath: resourcepath,
      isshowlist: [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],

    };
  },
  mounted() {

      //  this.xuliezhenlistanim();
  },
  methods: {
    xuliezhenlistanim() {
      let starttime=this.starttime;
      let isloop=this.isloop;
      var iii = 0;
      setTimeout( ()=> {
        var xuliezhentimer = setInterval( ()=> {
          console.log(111);
          if (iii > 29) {
            if (isloop == 1) {
              iii = 0;
              this.isshowlist=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
              this.isshowlist[0]=1
            } else {
              clearInterval(xuliezhentimer);
              this.isshowlist=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            
              return false;
            }
          } else {
            iii++;
            this.isshowlist=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
            this.isshowlist[iii]=1
       
          }
        }, 60);
      }, starttime);
    },
  },
  computed: {
    ...mapState([
      "suodingtipcss",
      "yujiazaicss",
      "sharetipcontainercss",
      "morentanchuangcss",
      "chuangtitle",
      "fn",
      "jindu",
      "starcss",
      "isalljiazai",
      "isplaybgmusic",
    ]),
  },
};
</script>
<style lang="scss"  scoped>
.xuliezhen{
  width:5.2rem;
  height: 4rem;
  position: absolute;
  left:20%;
  top:30%;
  img{
    width:100%;
    height:100%;
    position: absolute;
    left:0px;
    top:0px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/xuliezhen.vue